export default "__VITE_ASSET__f6ec21d6__"